/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "DER_Split_Error",
        type: "error",
    },
    {
        inputs: [],
        name: "addKeypair_403",
        type: "error",
    },
    {
        inputs: [],
        name: "expmod_Error",
        type: "error",
    },
    {
        inputs: [],
        name: "internal_keypairByAddress_404",
        type: "error",
    },
    {
        inputs: [],
        name: "internal_keypairForGvidByAddress_403",
        type: "error",
    },
    {
        inputs: [],
        name: "internal_keypairForGvidByAddress_404",
        type: "error",
    },
    {
        inputs: [],
        name: "internal_randomKeypair_404",
        type: "error",
    },
    {
        inputs: [],
        name: "internal_randomKeypair_418",
        type: "error",
    },
    {
        inputs: [],
        name: "k256Decompress_Invalid_Length_Error",
        type: "error",
    },
    {
        inputs: [],
        name: "k256DeriveY_Invalid_Prefix_Error",
        type: "error",
    },
    {
        inputs: [],
        name: "makeVoteTransaction_401",
        type: "error",
    },
    {
        inputs: [],
        name: "makeVoteTransaction_403",
        type: "error",
    },
    {
        inputs: [],
        name: "makeVoteTransaction_404",
        type: "error",
    },
    {
        inputs: [],
        name: "makeVoteTransaction_nonce",
        type: "error",
    },
    {
        inputs: [],
        name: "onPollClosed_404",
        type: "error",
    },
    {
        inputs: [],
        name: "onPollCreated_409",
        type: "error",
    },
    {
        inputs: [],
        name: "proxy_403",
        type: "error",
    },
    {
        inputs: [],
        name: "proxy_500",
        type: "error",
    },
    {
        inputs: [],
        name: "recoverV_Error",
        type: "error",
    },
    {
        inputs: [],
        name: "withdraw_401",
        type: "error",
    },
    {
        inputs: [],
        name: "withdraw_403",
        type: "error",
    },
    {
        inputs: [],
        name: "withdraw_404",
        type: "error",
    },
    {
        inputs: [],
        name: "withdraw_412",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes",
                name: "signedTransaction",
                type: "bytes",
            },
        ],
        name: "GasWithdrawTransaction",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "in_dao",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
        ],
        name: "addKeypair",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "in_dao",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
        ],
        name: "listAddresses",
        outputs: [
            {
                internalType: "address[]",
                name: "out_addrs",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "out_balances",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "in_addr",
                type: "address",
            },
            {
                internalType: "uint64",
                name: "in_nonce",
                type: "uint64",
            },
            {
                internalType: "uint256",
                name: "in_gasPrice",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "voter",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "dao",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "proposalId",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "choiceId",
                        type: "uint8",
                    },
                ],
                internalType: "struct VotingRequest",
                name: "in_request",
                type: "tuple",
            },
            {
                internalType: "bytes",
                name: "in_data",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "r",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "s",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "v",
                        type: "uint256",
                    },
                ],
                internalType: "struct SignatureRSV",
                name: "in_rsv",
                type: "tuple",
            },
        ],
        name: "makeVoteTransaction",
        outputs: [
            {
                internalType: "bytes",
                name: "output",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
        ],
        name: "onPollClosed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "in_creator",
                type: "address",
            },
        ],
        name: "onPollCreated",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
        ],
        name: "onPollDestroyed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "nonce",
                type: "uint64",
            },
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "subcall_data",
                type: "bytes",
            },
        ],
        name: "proxyDirect",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "in_dao",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "in_keypairAddress",
                type: "address",
            },
            {
                internalType: "uint64",
                name: "in_nonce",
                type: "uint64",
            },
            {
                internalType: "uint256",
                name: "in_amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "in_gasPrice",
                type: "uint256",
            },
            {
                internalType: "uint64",
                name: "in_gasLimit",
                type: "uint64",
            },
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "r",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "s",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "v",
                        type: "uint256",
                    },
                ],
                internalType: "struct SignatureRSV",
                name: "rsv",
                type: "tuple",
            },
        ],
        name: "withdraw",
        outputs: [
            {
                internalType: "bytes",
                name: "transaction",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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$231869a94ec2a9c38714b9bac2c988241d$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";
const isSuperArgs = (xs) => {
    return (typeof xs[0] === "string" ||
        Array.isArray(xs[0]) ||
        "_isInterface" in xs[0]);
};
export class GaslessVoting__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            const [linkLibraryAddresses, signer] = args;
            super(_abi, GaslessVoting__factory.linkBytecode(linkLibraryAddresses), signer);
        }
    }
    static linkBytecode(linkLibraryAddresses) {
        let linkedBytecode = _bytecode;
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$231869a94ec2a9c38714b9bac2c988241d\\$__", "g"), linkLibraryAddresses["contracts/CalldataEncryption.sol:CalldataEncryption"]
            .replace(/^0x/, "")
            .toLowerCase());
        return linkedBytecode;
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
GaslessVoting__factory.bytecode = _bytecode;
GaslessVoting__factory.abi = _abi;
//# sourceMappingURL=GaslessVoting__factory.js.map